import { render, staticRenderFns } from "./modifyName.vue?vue&type=template&id=8a3878ac"
import script from "./modifyName.vue?vue&type=script&lang=js"
export * from "./modifyName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports